// Mock data for Label Binduu Jain clone
export const heroImage = "https://images.unsplash.com/photo-1622277430358-f4d134452e2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwZHJlc3MlMjBzaWxob3VldHRlfGVufDB8fHx8MTc4ODE1MjgwMHww&ixlib=rb-4.1.0&q=85";

export const oneWomanImage = "https://images.unsplash.com/photo-1614750880774-6e5cb149607b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3V0dXJlJTIwYnJpZGFsJTIwZ293bnxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3ODgxNTI3OTR8MA&ixlib=rb-4.1.0&q=85";

export const oneDesignImage = "https://images.unsplash.com/photo-1585241920473-b472eb9ffbae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZHJlc3MlMjBzaWxob3VldHRlfGVufDB8fHx8MTc4ODE1MjgwMHww&ixlib=rb-4.1.0&q=85";

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/pages/about" },
  { label: "Register Your Interest", href: "/pages/waitlist-registration" },
];

export const faqItems = [
  {
    q: "What is Label Binduu Jain?",
    a: "Label Binduu Jain is a private couture house. Each design is composed for one woman alone — made once, and never repeated. Commissions are extended by invitation only."
  },
  {
    q: "How does the commission process work?",
    a: "Once your registration is received and an invitation is extended, we begin with a private conversation about your story, your memory, and your vision. From there, the atelier develops sketches, fabric studies, and embroidery swatches over several months."
  },
  {
    q: "How long does a commission take?",
    a: "Every creation is entirely handmade and typically requires between six and twelve months, depending upon the intricacy of embroidery and the number of fittings the piece asks for."
  },
  {
    q: "Do you ship worldwide?",
    a: "Yes. Once your gown is complete, our team arranges private, insured delivery to any destination in the world."
  },
  {
    q: "Can two women receive similar designs?",
    a: "No. Every Label Binduu Jain design belongs solely to the woman for whom it was created. Once complete, it is complete forever."
  }
];
